module.exports = __webpack_public_path__ + "img/908768cafa5c16a746adda1164188692.png";